<div class="topDiv" [style.background-color]="backgroundColorScreen">
  <div class="agGridOuterDiv" style="height: -webkit-fill-available">
     
      <!-- <div style="border-bottom: 0.01px ridge coral; margin: 15px 15px 15px 15px;"></div> -->
      <div style="display: flex;">
          <!-- <div class="col-lg-2" style="padding:0;"></div> -->
          <div  class="col-lg-12" style="padding:0;">
              <div class="row" style="display: block;margin-right: 5px;margin-left: 0;">
                  <div class="col-lg" style="padding:0;">
                    <div>
                      <mat-expansion-panel [expanded] = "true" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-top: 3%;">
                        <mat-expansion-panel-header style="max-height: 50px; background: rgb(228 227 230 / 50%);border: 1px solid #a9a9a9a8;">
                        <mat-panel-title>
                          <label style="font-size: 22px; font-weight: 500;" i18n="@@spmsUserReg" class="textColour">Web Content and Data Extraction</label>
                            <span class="example-spacer"></span>
                        </mat-panel-title>
                        <!-- <mat-panel-description>
                
                        </mat-panel-description> -->
                      </mat-expansion-panel-header>
                      <div style="margin-left: -35px;">
                      <mat-toolbar class="agGridtoperDiv card" style="
                            background: rgb(228 227 230 / 50%);
                            border-top:none ;
                            border-left: 1px solid #a9a9a9a8 ;
                            border-right: 1px solid #a9a9a9a8 ;
                            margin-top: 0%;border-radius: unset;">
                        <span class="example-spacer"></span>
                        <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "getScrapingHistory()">
                          Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                      </button>
                      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Add Record" (click) = "openSaveForm('Save')" [disabled]="isdisable">Add Record<em style="padding: 0px 0px 0px 10px;" class="fas fa-plus-circle" title="Add Record"></em>

                      </button>
                        <div class="insertPageNoDiv">
                          <mat-form-field appearance="outline">
                            <mat-label i18n="@@Targetpageno">Page No</mat-label>
                            <input matInput type="text" (input)="onHistorySearchChange($event.target.value)">
                          </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                          <mat-form-field appearance="outline" style="width:100%">
                            <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                            <mat-select [(ngModel)]="historyPageSize" (ngModelChange)="onHistoryPageSizeChanged(historyValue)">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                            </mat-select>
            
                          </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                          <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onHistoryBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                          <ul>
                            <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                                            (click)="onHistoryBtPrevious()"></em></li>
                            <li>{{historyCurrentPage}}/{{historyTotalPages}}</li>
                            <li class="paginationliicon" style="padding:0;"><em
                              class="fas fa-angle-right waves-effect waves-light" (click)="onHistoryBtNext()"></em></li>
                          </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                          <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onHistoryBtLast()"></em>
                        </div>
                      </mat-toolbar>
          
                    <!-- (rowSelected)="onRowSelected($event)" -->
                    <ag-grid-angular #Grid class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
                                     style="height: 50vh;"
                                     [columnDefs]="historyColumnDefs" 
                                     [pagination]="true"
                                      [animateRows]="true"
                                     [components]="components" 
                                     [defaultColDef]="historyColDef" [suppressPaginationPanel]="true" [rowSelection]="historyRowSelection"
                                     [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                                     [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                                     [enableRangeSelection]="true" [debug]="true" (gridReady)="onHistoryGridReady($event)"
                                     [isRowSelectable]="isRowSelectable"
                                     (rowSelected)="onHistoryRowSelected($event)"
                                     (paginationChanged)="onHistoryPaginationChanged()"
                                     [gridOptions]="gridOptions"
                                     [hidden]="!true">
                    </ag-grid-angular>
                    <!--  -->
                    <div style="    border: 1px solid #c6c6c6;border-top: 0px;text-align: center;">
                    <div style="width: 100%;text-align: center;">
                      <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Start Scraping"  (click) = "onCompareClick()">Compare
                      </button>
                    </div>
                    </div>
                    </div>
                   </mat-expansion-panel>
                   </div>
                  </div>
          
              </div>
          </div>
          <!-- <div class="col-lg-2" style="padding:0;"></div> -->
      </div>

      <div style="display: flex;">
        <!-- <div class="col-lg-2" style="padding:0;"></div> -->
        <div  class="col-lg-12" style="padding:0;">
            <div class="row" style="display: block;margin-right: 5px;margin-left: 0;">
                <div class="col-lg" style="padding:0;">
                  <div>
                    <mat-expansion-panel [expanded] = "false" style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-top: 3%;margin-bottom: 5%;">
                      <mat-expansion-panel-header style="max-height: 50px; background: rgb(228 227 230 /50%);border: 1px solid #a9a9a9a8;">
                      <mat-panel-title>
                        <label style="font-size: 22px; font-weight: 500;" i18n="@@spmsUserReg" class="textColour">Compare History</label>
                          <span class="example-spacer"></span>
                      </mat-panel-title>
                      <mat-panel-description>
              
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div style="margin-left: -35px;">
                    <mat-toolbar class="agGridtoperDiv card" style="
                          background: rgb(228 227 230 / 50%);
                          border-top:none ;
                          border-left: 1px solid #a9a9a9a8 ;
                          border-right: 1px solid #a9a9a9a8 ;
                          margin-top: 0%;border-radius: unset;">
                      <span class="example-spacer"></span>
                      <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "getCompareHistory()">
                        Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                    </button>
                      <div class="insertPageNoDiv">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@Targetpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onCompareHistorySearchChange($event.target.value)">
                        </mat-form-field>
                      </div>
                      <div class="selectRecordsDiv" style="width:9.5%">
                        <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                          <mat-select [(ngModel)]="compareHistoryPageSize" (ngModelChange)="onCompareHistoryPageSizeChanged(historyValue)">
                            <mat-option value="10" selected>10</mat-option>
                            <mat-option value="200">200</mat-option>
                            <mat-option value="300">300</mat-option>
                            <mat-option value="400">400</mat-option>
                          </mat-select>
          
                        </mat-form-field>
                      </div>
                      <div class="card pagination paginationFirstButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onCompareHistoryBtFirst()"></em>
                      </div>
                      <div class="card pagination paginationButtons btn-rounded">
                        <ul>
                          <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                                                          (click)="onCompareHistoryBtPrevious()"></em></li>
                          <li>{{compareHistoryCurrentPage}}/{{compareHistoryTotalPages}}</li>
                          <li class="paginationliicon" style="padding:0;"><em
                            class="fas fa-angle-right waves-effect waves-light" (click)="onCompareHistoryBtNext()"></em></li>
                        </ul>
                      </div>
                      <div class="card pagination paginationLastButton paginationFirstlastButton">
                        <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onCompareHistoryBtLast()"></em>
                      </div>
                    </mat-toolbar>
        
                  <!-- (rowSelected)="onRowSelected($event)" -->
                  <ag-grid-angular #Grid class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
                                   style="height: 50vh;"
                                   [columnDefs]="compareHistoryColumnDefs"  [animateRows]="true"
                                   [components]="components" 
                                   [pagination]="true"
                                   [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                                   [defaultColDef]="compareHistoryColDef" [suppressPaginationPanel]="true" 
                                   [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                                   [enableRangeSelection]="true" [debug]="true" (gridReady)="onCompareHistoryGridReady($event)"
                                   (paginationChanged)="onCompareHistoryPaginationChanged()"
                                   [hidden]="!true">
                  </ag-grid-angular>
                  <!-- <div style="    border: 1px solid #c6c6c6;border-top: 0px;text-align: center;">
                  <div style="width: 100%;text-align: center;">
                    <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Start Scraping" (click) = "onCompareClick()">Compare
                    </button>
                  </div>
                  </div> -->
                  </div>
                 </mat-expansion-panel>
                 </div>
                </div>
        
            </div>
        </div>
        <!-- <div class="col-lg-2" style="padding:0;"></div> -->
    </div>
  </div>
</div>
